export default __webpack_public_path__ + "static/media/lucky-macbook-img1.91ae016f.png";